import { bhStoreApiRequest } from '@lib/request'
import { Customer } from '@medusajs/medusa'
import { useCallback, useEffect, useState } from 'react'

/** Return a boolean for whether or not the provided customer's account is
 * in regional (free shipping) group or not. */
function useCustomerIsRegional(
  customer?: Omit<Customer, 'password_hash'>
): boolean {
  const [isRegional, setIsRegional] = useState(false)
  const checkIsRegional = useCallback(async () => {
    if (customer) {
      // check if the customer is a b2b customer
      const { data } = await bhStoreApiRequest<{
        isRegional: boolean
      }>(`/customers/is-regional`)
      setIsRegional(data.isRegional)
    } else {
      setIsRegional(false)
    }
  }, [customer])

  useEffect(() => {
    checkIsRegional()
  }, [checkIsRegional])

  return isRegional
}

export default useCustomerIsRegional
